import Vue from "vue";
import Vuex from "vuex";
import axios from "../plugins/axios";
import api from "../api";

import { chat } from "./chat";
import { common } from "./common";
import { expo } from "./expo";
import { interview } from "./interview";
import { lecture } from "./lecture";
import { ui } from "./ui";

Vue.use(Vuex);

var refreshToken = sessionStorage.getItem("refreshToken");
var accessToken = sessionStorage.getItem("accessToken");

var payload = JSON.parse(atob(accessToken?.split(".")[1] || "") || "{}");
var scope = payload?.scope || [];
var session = sessionStorage.getItem("session");

export default new Vuex.Store({
    state: {
        refreshToken,
        accessToken,
        payload,
        scope,
        session,
        user: undefined,

        likes: undefined,
        _carts: JSON.parse(sessionStorage.getItem("_carts") || "[]"), // 장바구니 상품
        _pickups: JSON.parse(sessionStorage.getItem("_pickups") || "[]"), // 주문 픽업상품

        agreements: JSON.parse(sessionStorage.getItem("agreements") || "[]"),
    },
    getters: {
        _user(state) {
            return state.payload?._user;
        },
        userType(state) {
            return state.payload?.userType;
        },
        isUserLoggedIn(state) {
            return !!state.accessToken;
        },
        doesUserHaveConsoleScope(state) {
            return (state.scope || []).includes("console");
        },
    },
    mutations: {
        agreements(state, agreements) {
            state.agreements = agreements;

            sessionStorage.setItem("agreements", JSON.stringify(agreements));
        },
        login(state, { refreshToken, accessToken }) {
            state.refreshToken = refreshToken;
            state.accessToken = accessToken;

            state.payload = JSON.parse(atob(accessToken?.split(".")[1] || "") || "{}");
            state.scope = state.payload?.scope || [];
            state.likes = undefined;

            axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

            sessionStorage.setItem("refreshToken", refreshToken);
            sessionStorage.setItem("accessToken", accessToken);
        },

        logout(state) {
            state.refreshToken = undefined;
            state.accessToken = undefined;

            state.payload = {};
            state.scope = [];
            state.user = undefined;

            axios.defaults.headers.common["Authorization"] = "";

            sessionStorage.removeItem("refreshToken");
            sessionStorage.removeItem("accessToken");
        },

        setSession(state, { session }) {
            if (session) {
                sessionStorage.setItem("session", session);
                axios.defaults.headers.common["session"] = session;
            } else {
                sessionStorage.removeItem("session");
                delete axios.defaults.headers.common["session"];
            }

            state.session = session;
        },

        setUser(state, { user }) {
            state.user = user;
        },

        addToCart(state, _carts) {
            state._carts = _carts;
            sessionStorage.setItem("_carts", JSON.stringify(_carts));
        },

        checkout(state, _pickups) {
            state._pickups = _pickups;
            sessionStorage.setItem("_pickups", JSON.stringify(_pickups));
        },

        setLikes(state, { likes }) {
            state.likes = likes;
        },
    },
    actions: {
        agreements({ commit }, _terms) {
            commit("agreements", _terms);
        },

        async login({ commit }, { username, password }) {
            var { refreshToken } = await api.auth.getRefreshToken({ username, password });
            var { accessToken } = await api.auth.getAccessToken(refreshToken);

            commit("login", { refreshToken, accessToken });
        },

        logout({ commit, dispatch }) {
            commit("logout");
            dispatch("chat/reset");
        },

        async refresh({ commit }, refreshToken) {
            var { accessToken } = await api.auth.getAccessToken(refreshToken);

            commit("login", { refreshToken, accessToken });
        },

        async getSession({ commit }, { referrer } = {}) {
            const { _session } = await api.session.get({ params: { referrer } });
            commit("setSession", { session: _session });
        },

        async getUser({ commit }) {
            const { user } = await api.v1.me.get();
            commit("setUser", { user });
        },

        addToCart({ commit }, _carts) {
            commit("addToCart", _carts);
        },

        checkout({ commit }, _pickups) {
            commit("checkout", _pickups);
        },

        async getLikes({ commit }) {
            const { likes } = await api.v1.me.likes.gets();
            commit("setLikes", { likes });
        },
    },
    modules: {
        chat,
        common,
        expo,
        interview,
        lecture,
        ui,
    },
});
